import React from "react";
import { Mail, Send, BellRing } from "lucide-react";

function Subscribtion() {
  return (
    <section className="container max-w-7xl mx-auto mt-12 md:mt-16 lg:mt-20 px-4 sm:px-5 md:px-6 lg:px-4">
      {/* Main Banner Container */}
      <div className="relative overflow-hidden w-full min-h-[240px] sm:min-h-[260px] md:min-h-[280px] rounded-2xl sm:rounded-3xl md:rounded-[30px] bg-gradient-to-br from-[#163A8F] via-[#1e4eb8] to-[#163A8F] shadow-xl md:shadow-2xl flex flex-col lg:flex-row items-center justify-between px-4 sm:px-6 md:px-8 lg:px-16 xl:px-20 py-6 sm:py-8 md:py-10 gap-6 md:gap-8 lg:gap-10">
        {/* Background Decorative Element */}
        <div className="absolute -bottom-10 -left-10 opacity-5 sm:opacity-10 pointer-events-none hidden sm:block">
          <Mail
            size={200}
            className="sm:w-[250px] sm:h-[250px] md:w-[300px] md:h-[300px] text-white rotate-12"
          />
        </div>

        {/* Text Content Area */}
        <div
          className="relative z-10 flex flex-col gap-3 sm:gap-4 text-center lg:text-right w-full lg:w-auto"
          dir="rtl"
        >
          <div className="flex flex-col gap-1 sm:gap-2">
            <div className="flex items-center justify-center lg:justify-start gap-2 sm:gap-3">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight">
                النشرة البريدية
              </h2>
              <BellRing
                className="text-amber-400 animate-bounce hidden lg:block"
                size={24}
              />
            </div>
            <p className="text-blue-100 text-sm sm:text-base md:text-lg lg:text-xl font-medium opacity-90 max-w-md mx-auto lg:mx-0">
              اشترك الآن بالنشرة البريدية ليصل كل جديد منا مباشرة إلى بريدك.
            </p>
          </div>

          {/* INTEGRATED INPUT BAR */}
          <div className="mt-2 sm:mt-3 md:mt-4 flex flex-col sm:flex-row items-stretch sm:items-center p-1 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl sm:rounded-2xl w-full max-w-lg mx-auto lg:mx-0 focus-within:bg-white focus-within:border-white transition-all group">
            <div className="grow flex items-center px-3 sm:px-4 gap-2 sm:gap-3 py-2 sm:py-0">
              <Mail
                className="text-blue-200 group-focus-within:text-blue-600 transition-colors shrink-0"
                size={18}
              />
              <input
                type="email"
                placeholder="بريدك الإلكتروني"
                className="bg-transparent py-2 sm:py-3 w-full outline-none text-white group-focus-within:text-zinc-800 placeholder-blue-100 group-focus-within:placeholder-zinc-400 font-medium text-xs sm:text-sm"
              />
            </div>

            <button className="flex items-center justify-center gap-1 sm:gap-2 bg-amber-400 hover:bg-amber-500 text-neutral-900 font-bold px-4 sm:px-6 md:px-8 py-2.5 sm:py-3 rounded-xl transition-all active:scale-95 whitespace-nowrap shadow-lg mx-1 mb-1 sm:m-0 text-xs sm:text-sm">
              <span>اشتراك</span>
              <Send size={14} />
            </button>
          </div>
        </div>

        {/* Feature Illustration */}
        <div className="hidden lg:flex relative items-center justify-center w-[200px] xl:w-[250px]">
          <div className="relative animate-pulse">
            <svg
              width="257"
              height="185"
              viewBox="0 0 257 185"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-full h-auto"
            >
              <g clipPath="url(#clip0_sub)">
                <path
                  d="M165.195 71.9518L176.188 108.869C176.369 109.476 176.681 110.025 177.099 110.47C177.516 110.914 178.027 111.239 178.585 111.418C179.143 111.596 179.732 111.622 180.302 111.494C180.871 111.365 181.404 111.086 181.853 110.68L214.678 80.9174C214.678 80.9174 179.795 65.9912 179.795 66.7973C179.795 67.6033 165.195 71.9518 165.195 71.9518Z"
                  fill="#274182"
                />
                <path
                  d="M251.816 1.00268C230.374 10.3166 161.171 41.5024 134.98 53.2443C134.219 53.586 133.572 54.1772 133.128 54.9373C132.685 55.6973 132.465 56.5892 132.5 57.4912C132.534 58.3933 132.822 59.2617 133.322 59.9779C133.823 60.6942 134.513 61.2234 135.297 61.4935L165.204 71.9518L176.161 108.77C176.363 109.453 176.73 110.064 177.223 110.537C177.717 111.01 178.317 111.328 178.961 111.456C179.967 111.665 181.454 81.6538 181.454 81.6538C181.454 81.6538 212.892 107.257 227.8 119.347C228.646 120.03 229.635 120.466 230.675 120.616C231.715 120.766 232.773 120.624 233.75 120.204C234.727 119.784 235.592 119.099 236.263 118.213C236.934 117.327 237.39 116.27 237.588 115.138L256.928 5.67954C257.06 4.94619 257.01 4.18714 256.783 3.48228C256.556 2.77742 256.16 2.1528 255.637 1.67415C255.114 1.1955 254.483 0.880526 253.811 0.76236C253.138 0.644195 252.449 0.727212 251.816 1.00268Z"
                  fill="#D2DFFF"
                />
                <path
                  d="M178.952 111.446C179.958 111.655 181.445 81.6438 181.445 81.6438L233.102 28.3772C233.178 28.3044 233.227 28.2025 233.237 28.092C233.248 27.9816 233.22 27.8709 233.159 27.7824C233.097 27.6939 233.008 27.6342 233.248 27.6153C233.097 27.6939 233.008 27.6342 232.908 27.6153C232.809 27.5964 232.706 27.6198 232.622 27.6807L165.195 71.9517L176.152 108.77C176.356 109.452 176.724 110.06 177.216 110.532C177.709 111.003 178.309 111.319 178.952 111.446Z"
                  fill="#274182"
                />
                <path
                  d="M0 183.709C35.4714 183.59 82.6337 161.628 92.0952 119.457C95.9196 102.431 92.5211 84.2012 80.2321 71.7826C64.7077 56.0803 47.6607 70.4293 51.8568 92.331C58.7444 128.323 98.7834 155.021 129.207 155.349C146.798 155.568 163.292 146.314 169.617 127.388"
                  stroke="#D2DFFF"
                  strokeOpacity="0.38"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                  strokeDasharray="5 5"
                />
              </g>
              <defs>
                <clipPath id="clip0_sub">
                  <rect
                    width="257"
                    height="184"
                    fill="white"
                    transform="translate(0 0.704102)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Subscribtion;
